module.exports = __webpack_public_path__ + "static/media/T1.f7f9273e.jpeg";